
import React, { useEffect, useRef, useState } from 'react';
import PDFDocument from './secure-doc-view.component';
import DroppedFieldComponent from './dropped-field.component';
import { useSelector } from 'react-redux';
import * as selector from "../../selectors/selectors"

export interface DroppedField {
    id: string;
    type: string;
    label: string;
    x: number;
    y: number;
    width: number;
    height: number;
    page?: number;
    assignedRecipient?: string;
}
export interface DragState {
    isDragging: boolean;
    dragType: 'new' | 'existing' | null;
    dragData: any;
    startPos: { x: number; y: number };
    currentPos: { x: number; y: number };
}

export interface FieldType {
    id: string;
    type: string;
    label: string;
    icon: JSX.Element;
}

interface PDFContainerProps {
    droppedFields: DroppedField[];
    fileID?: string;
    selectedFieldId: string | null;
    onFieldDrop: (field: FieldType, position: { x: number; y: number }, page: number) => void;
    onFieldUpdate: (id: string, updates: Partial<DroppedField>) => void;
    onFieldDelete: (id: string) => void;
    onFieldSelect: (id: string | null) => void;
    onFieldDragStart: (field: DroppedField, startPos: { x: number; y: number }) => void;
    dragState: DragState;
    recipientRestrictions?: Map<string, { canEdit: boolean, canAdd: boolean }>;
    onConfiguredFieldsLoad?: (fields: DroppedField[], recipients: any[]) => void;
    recipientEmails?: { recipient_id: string, email: string; order_number: number }[];
    pdfBase64?: string | null;
}

const MainPdfBuilderComponent: React.FC<PDFContainerProps> = ({
    droppedFields,
    fileID,
    selectedFieldId,
    onFieldDrop,
    onFieldUpdate,
    onFieldDelete,
    onFieldSelect,
    onFieldDragStart,
    dragState,
    recipientRestrictions,
    onConfiguredFieldsLoad,
    recipientEmails,
    pdfBase64,
}) => {
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const containerRef = useRef<HTMLDivElement>(null);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [numPages, setNumPages] = useState<number>(0);
    const [fileId, setFileId] = useState<string>(fileID);
    const [fileName, setFileName] = useState<string>("");
    const [fileType, setFileType] = useState<string>("");
    const [fileBase64, setFileBase64] = useState<string>("");

    const handleClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onFieldSelect(null);
        }
    };

    const handleMouseUp = (e: React.MouseEvent) => {
        if (dragState.isDragging && dragState.dragType === 'new') {
            const pageWrapper = document.querySelector('.pdf-page-wrapper');
            if (pageWrapper) {
                const rect = pageWrapper.getBoundingClientRect();
                if (e.clientX >= rect.left && e.clientX <= rect.right &&
                    e.clientY >= rect.top && e.clientY <= rect.bottom) {
                    const relativeX = e.clientX - rect.left;
                    const relativeY = e.clientY - rect.top;
                    const adjustedX = Math.max(0, relativeX - 75);
                    const adjustedY = Math.max(0, relativeY - 20);
                    onFieldDrop(dragState.dragData, { x: adjustedX, y: adjustedY }, currentPage);
                }
            }
        }
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    const handleLoadSuccess = (totalPages: number) => {
        setNumPages(totalPages);
    };


    return (
        <div
            ref={containerRef}
            className={`p-relative h-p-100 ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-secondary"} d-flex flex-direction ${dragState.isDragging && dragState.dragType === 'new'
                ? 'canvas-default'
                : 'canvas-default'
                }`}
            onClick={handleClick}
            onMouseUp={handleMouseUp}
        >
            <div className='p-relative flex-1'>
                <PDFDocument
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    onLoadSuccess={handleLoadSuccess}
                    showNavigation={true}
                    width={800}
                    fields={droppedFields}
                    selectedFieldId={selectedFieldId}
                    onFieldSelect={onFieldSelect}
                    onFieldDelete={onFieldDelete}
                    onFieldDragStart={onFieldDragStart}
                    onFieldUpdate={onFieldUpdate}
                    recipientRestrictions={recipientRestrictions}
                    fileID={fileID}
                    onConfiguredFieldsLoad={onConfiguredFieldsLoad}
                    recipientEmails={recipientEmails}
                    pdfBase64={pdfBase64}
                />
            </div>
        </div>
    );

};

export default MainPdfBuilderComponent;